import { useState, useEffect } from "react";
import { Typography } from "antd";
import axios from "axios";
import SLInfo from "./SLInfo";
import StandardSubSettings from "./SettingsComponents/StandardSubSettings";

const SL = ({ settings, setHaveNewData, isMobile, apiAdd }) => {
  let localSettings = StandardSubSettings(settings, "SL");

  const [finalData, setFinalData] = useState([]);
  const [initial, setInitial] = useState(true);

  const [alertData, setAlertData] = useState([]);

  let line = localSettings.line;

  function APIcall() {
    const getAPI = async () => {
      const apiFromServer = await axios(
        "http://baryonproxy-env.eba-yzpd4nkz.eu-west-1.elasticbeanstalk.com/deviation/" +
          line
      );
      return apiFromServer.data;
    };

    let filteredOutput = {};
    let idList = [];

    getAPI().then((r) => {
      filteredOutput.StatusCode = r.StatusCode;
      filteredOutput.Message = r.Message;
      filteredOutput.ExecutionTime = r.ExecutionTime;
      filteredOutput.ResponseData = [];
      if(r.ResponseData){
        for (let i = 0; i < r.ResponseData.length; i++) {
          if (!idList.includes(r.ResponseData[i].DevCaseGid)) {
            delete r.ResponseData[i]["SiteId"];
            idList.push(r.ResponseData[i].DevCaseGid);
            filteredOutput.ResponseData.push(r.ResponseData[i]);
          }
        }
      }
      setAlertData(filteredOutput.ResponseData);
    });
  }

  useEffect(() => {
    APIcall();
    const interval = setInterval(APIcall, 900000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let valueArray = [];

  function SLHaveNewDataCallback(value) {
    valueArray.push(value);

    if (valueArray.includes(true)) {
      setHaveNewData(true);
    } else {
      setHaveNewData(false);
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const sendInfo = () => {
    if (alertData[0] != null) setInitial(false);

    //console.log("This is alert data: " + JSON.stringify(alertData))
    if (alertData[0] != null) {
      alertData.forEach((value, index) => {
        const dateFormated = value.Updated.replace("latest_update ", "")
          .replaceAll(new RegExp(/\.\d*\+/, "gm"), "")
          .replaceAll("-", "")
          .replaceAll("T", "")
          .replaceAll(":", "");
        console.log("Formated date: " + dateFormated);
        setFinalData((finalData) => [
          ...finalData,
          {
            idArray: 3,
            key: value.DevCaseGid,
            id: value.DevCaseGid,
            desc: value.Details,
            header: value.Header,
            line: value.ScopeElements,
            time: value.Created,
            date: dateFormated,
            mainNews: value.MainNews,
            callback: SLHaveNewDataCallback,
            settings: { settings },
          },
        ]);
      });
    }
  };

  useEffect(() => {
    if (isMobile === "true") apiAdd(finalData);
  }, [finalData]);

  useEffect(() => {
    if (initial && isMobile === "true") {
      console.log("attempt");
      sendInfo();
    }
  }, [alertData]);

  var apiData = alertData.map((value) => {
    return (
      <>
        {isMobile === "true" ? (
          <></>
        ) : (
          <SLInfo
            key={value.DevCaseGid}
            id={value.DevCaseGid}
            desc={value.Details}
            header={value.Header}
            line={value.ScopeElements}
            time={value.Created}
            mainNews={value.MainNews}
            callback={SLHaveNewDataCallback}
            settings={settings}
          />
        )}
      </>
    );
  });

  var empty = apiData.length === 0;

  return (
    <>
      {empty ? (
        <>
          {isMobile === "true" ? (
            <></>
          ) : (
            <>
              <Typography.Title level={5} className="tileHeader">
                Inga störningar på dina valda linjer
              </Typography.Title>
            </>
          )}
        </>
      ) : (
        <>{apiData}</>
      )}
    </>
  );
};

export default SL;
